import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

interface SignupsChartProps {
  data: Array<{ week: number; year: number; count: number; weekStart: string }>;
}

export function SignupsChart({ data }: SignupsChartProps) {
  const chartData = data.map((d) => ({
    label: `W${d.week}`,
    count: d.count,
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <XAxis dataKey="label" stroke="#aaa" fontSize={12} />
        <YAxis stroke="#aaa" fontSize={12} />
        <Tooltip />
        <Bar dataKey="count" fill="#6366f1" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
